import { Button, Divider, Grid, Popover, Typography } from '@mui/material'
import React, { useContext, useMemo } from 'react'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { ProviderIncomeDashboard } from '../IncomeDashboard';
import CheckBoxClear from '../CheckBoxClear';
import SwitchBoxClear from '../SwitchBoxClear';
import { RadioBoxClear } from '../RadioBoxClear';
import moment from 'moment';

const BoxSearch = () => {

    const {
        option,
        arrYear,
        setArrYear,
        arrMonth,
        setArrMonth,
        arrMuseum,
        setArrMuseum,
        isCheckYear,
        setIsCheckYear,
        rYear,
        setrYear
    } = useContext(ProviderIncomeDashboard);

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleDisplay = (isYear) => {
        if (isYear) {
            const nYearSelect = parseInt(moment().format('YYYY'));
            setrYear(nYearSelect)
            let arrMonthId = [];
            for (let index = 1; index <= 12; index++) {
                arrMonthId.push(index + "");
            }
            setArrMonth(arrMonthId)
        }
    }

    const handleChangeYear = () => {
        let arrMonthId = [];
        for (let index = 1; index <= 12; index++) {
            arrMonthId.push(index + "");
        }
        setArrMonth(arrMonthId)
    }

    const arrOptionMonth = useMemo(() => {
        return ([
            { label: "มกราคม", value: "1", disabled : false },
            { label: "กุมภาพันธ์", value: "2", disabled : false },
            { label: "มีนาคม", value: "3", disabled : false }, 
            { label: "เมษายน", value: "4", disabled : false },
            { label: "พฤภาคม", value: "5", disabled : false },
            { label: "มิถุนายน", value: "6", disabled : false },
            { label: "กรกฎาคม", value: "7", disabled : false },
            { label: "สิงหาคม", value: "8", disabled : false },
            { label: "กันยายน", value: "9", disabled : false },
            { label: "ตุลาคม", value: "10", disabled : false },
            { label: "พฤศจิกายน", value: "11", disabled : false },
            { label: "ธันวาคม", value: "12", disabled : false },
        ])
    }, [])

    return (
        <div>
            <Button
                id='search-popover'
                variant="contained"
                size={'small'}
                startIcon={<TuneRoundedIcon />}
                onClick={handleClick}
                sx={() => ({
                    zIndex: 10002,
                    boxShadow: 'none',
                    textTransform: 'none',
                    color: "#001f41",
                    backgroundColor: "#dcdcdc",
                    borderRadius: "8px",
                    width: "36.5px",
                    minWidth: "20px",
                    height: "39.5px",
                    ":hover": {
                        bgcolor: "#bdbdbd",
                    },
                    ".MuiButton-startIcon": {
                        margin: "0 !important"
                    },
                })}

            >
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => { setAnchorEl(null) }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                style={{
                    width: '400px',
                    zIndex: 10002
                }}
            >
                <Grid container spacing={1} style={{ padding: "8px" }}>
                    <Grid item xs={12} >
                        <Typography fontWeight={500} fontSize={"1.3em"}>กรองข้อมูล</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} >
                        <Typography>การแสดงข้อมูล</Typography>
                        <SwitchBoxClear
                            id={"isYear"}
                            name={"isYear"}
                            uncheckText='เปรียบเทียบ'
                            checkText='รายปี'
                            width={150}
                            onColor='#f59a23'
                            offColor='#02a7f0'
                            fontColor='#ffffff'
                            value={isCheckYear}
                            setValue={setIsCheckYear}
                            onChange={(eValue) => {
                                setIsCheckYear(eValue);
                                handleDisplay(eValue);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <Divider />
                    </Grid>
                    <Grid item xs={12} >
                        {
                            isCheckYear ?
                                <div style={{ position: "relative" }}>
                                    <RadioBoxClear
                                        label={"ปี"}
                                        id='nYear'
                                        name={'nYear'}
                                        options={option.lstYear}
                                        value={rYear}
                                        setValue={setrYear}
                                        onChange={()=>{
                                            handleChangeYear()
                                        }}
                                        
                                    />
                                    <Divider />
                                </div>
                                :
                                <div style={{ position: "relative" }}>
                                    <Button onClick={() => { setArrYear([]) }} style={{ position: "absolute", right: 0, top: "-4px" }}>
                                        ล้าง
                                    </Button>
                                    <CheckBoxClear
                                        label={"ปี"}
                                        options={option.lstYear}
                                        arrSelect={arrYear}
                                        setArrSelect={setArrYear}
                                        isSelectAll={false}
                                    />
                                    <Divider />
                                </div>
                        }
                    </Grid>
                    <Grid item xs={12} >
                        <div style={{ position: "relative" }}>
                            <Button onClick={() => { setArrMuseum([]) }} style={{ position: "absolute", right: 0, top: "-4px" }}>
                                ล้าง
                            </Button>
                            <CheckBoxClear
                                label={"พิพิธภัณฑ์"}
                                options={option.lstMuseum}
                                arrSelect={arrMuseum}
                                setArrSelect={setArrMuseum}
                            />
                            <Divider />
                        </div>
                    </Grid>
                    {
                        isCheckYear ?
                            <Grid item xs={12} >
                                <div style={{ position: "relative" }}>
                                    <Button onClick={() => { setArrMonth([]) }} style={{ position: "absolute", right: 0, top: "-4px" }}>
                                        ล้าง
                                    </Button>
                                    <CheckBoxClear
                                        label={"เดือน"}
                                        arrSelect={arrMonth}
                                        setArrSelect={setArrMonth}
                                        options={arrOptionMonth}
                                    />
                                    <Divider />
                                </div>
                            </Grid>
                            : null
                    }
                </Grid>
            </Popover>
        </div>
    );
}

export default BoxSearch